export default __webpack_public_path__ + "static/sneakers1.inspirations-8e8f633925fd24285192d1075aa1aa4d.jpg";